import { AdState } from './ad-state';
import { isGetGameStartDataFinished } from '../general/modules/getGameStartData';

export class AdStateAuthFactory {
    public async getState(): Promise<AdState> {
        await isGetGameStartDataFinished();
        return new AdState(window.app.getGameStartDataResponse.human_data.refState);
    }
}
